var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavBenner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 118,
    viewBox: "0 0 86 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.025 2.38584C0.025 4.65251 -0.241667 8.65251 0.158333 45.3192L0.558333 85.8525L4.29167 93.3192C13.8917 113.186 34.825 122.386 55.4917 115.986C85.3583 107.053 95.7583 69.7192 75.0917 46.6525C66.1583 36.7858 56.6917 32.5192 43.225 32.5192C32.5583 32.5192 31.225 32.9192 15.625 40.9192C14.9583 41.1858 14.5583 33.0525 14.5583 22.7858C14.5583 6.51918 14.2917 3.98584 12.1583 2.11918C8.95833 -0.814158 4.825 -0.680825 2.025 2.38584ZM53.8917 49.0525C73.225 57.8525 77.3583 81.4525 62.025 95.5858C47.7583 108.653 26.6917 104.919 18.025 87.7192C13.8917 79.1858 13.625 72.1192 17.3583 63.8525C20.9583 55.8525 23.3583 53.3192 31.225 49.7192C39.225 45.9858 46.6917 45.7192 53.8917 49.0525Z",
    fill: "#ED1846"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5581 58.2525C24.9581 63.0525 21.3581 74.1191 26.2915 83.7191C33.4915 98.1191 53.6248 97.5858 60.1581 82.9191C67.4915 66.2525 50.8248 49.9858 34.5581 58.2525Z",
    fill: "#4646F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavBenner);
export default __webpack_public_path__ + "static/media/fav_benner.c1f06f581f9a1bf3943d09a4cf086dfb.svg";
export { ForwardRef as ReactComponent };